export default {
  "steps-vertical": {
    tender: {
      title: "We frame your tender",
      description:
        "We have defined the specifications for your optimal solar system independently of the contractors.",
    },
    publish: {
      title: "You publish your quote request",
      description:
        "You confirm the technical information in your specifications to get relevant proposals.",
    },
    published: {
      title: "Contractors receive your quote request",
      description:
        "Your request includes the technical file with your specifications, and excludes your contact details: no cold calling possible.",
    },
    quotes: {
      title: "You receive custom quotes",
      description:
        "Contractors choose their equipment while respecting your specifications and technical constraints.",
    },
  },

  "steps-horizontal": {
    "launch-tender": {
      title: "Launch your private tender",
      description:
        "For the start of your solar project, after studying your options and specifications together, launch a private tender with our approved installers. We support you throughout the process to answer your questions.",
    },
    quotes: {
      title: "Receive quotes from approved installers",
      description:
        "Once the tender is launched, receive proposals and quotes from our installers based on established parameters and their location. We encourage you to prioritize local craftsmanship.",
    },
    select: {
      title: "Choose your proposal and schedule the technical visit",
      description:
        "After reviewing the different proposals, choose the one that suits you. You can request support if you wish. Then schedule the technical visit to validate the feasibility of the project.",
    },
    "sign-contract": {
      title: "Sign the quote and you're off!",
      description:
        "After validating the project feasibility, sign the final quote. Your installation can then begin! Follow its progress from your dashboard.",
    },
  },
  auction: "Tender",
  hire: "Hire directly",
  "service-types": {
    installation_only: "Installation only",
    installation_and_hardware_supply: "Installation and supply of equipment",
    maintenance: "Maintenance",
    construction: "Construction work",
  },
} 